module.exports = __webpack_public_path__ + "img/logo-sgu.ed65f535.svg";